import React,{useRef, useState, useEffect} from 'react'
import { useNavigate} from 'react-router-dom'
import { ChatEngine } from 'react-chat-engine'
import { auth } from '../firebase'
import '../App.css'
import {useAuth} from '../contexts/AuthContext'
import logo from '../assets/logo3.png'
import axios from 'axios'


const Chats = ({ darkTheme, setDarkTheme, chat }) => {
  const didMountRef = useRef(false)
  const navigate = useNavigate()
  const {user} = useAuth()
  const [loading, setLoading] = useState(true)

  
  const handleLogout = async () => {
    await auth.signOut()

    navigate('/')
  }

  const getFile = async (url) => {
    const response = await fetch(url) 
    const data = await response.blob()

    return new File([data], "userPhoto.jpg", {type:'image/jpeg'})
  }

  useEffect(() => {
    if (!didMountRef.current) {
      didMountRef.current = true

      if (!user || user === null) {
        navigate("/")
        return
      }
      
      // Get-or-Create should be in a Firebase Function
      axios.get(
        'https://api.chatengine.io/users/me/',
        { headers: { 
          "project-id": '420244ae-4d3a-43bc-9d28-0ef1dbb8a64b',
          "user-name": user.email,
          "user-secret": user.uid,
        }}
      )

      .then(() => setLoading(false))

      .catch(e => {
        let formdata = new FormData()
        formdata.append('email', user.email)
        formdata.append('username', user.email)
        formdata.append('secret', user.uid)

        getFile(user.photoURL)
        .then(avatar => {
          formdata.append('avatar', avatar, avatar.name)

          axios.post(
            'https://api.chatengine.io/users',
            formdata,
            { headers: { "private-key": 'eb180a44-0715-487a-8191-7a5aaa62287b' }}
          )
          .then(() => setLoading(false))
          .catch(e => console.log('e', e.response))
        })
      })
      // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

    }
  }, [user, navigate])
  

  if (!user || loading) return <div />

  return (
    <div className="absolute w-full h-screen">
      <div className="relative h-20 bg-sky-600 dark:bg-slate-700 h">
        <div className="logo-tab">
          Unichat
        </div>
        <div onClick={handleLogout} className="font-semibold float-right px-8 mt-5 cursor-pointer text-white">
          Logout
        </div>
      </div>
      <ChatEngine
        height="calc(100vh - 66px)"
        projectID={"420244ae-4d3a-43bc-9d28-0ef1dbb8a64b"}
        userName={user.email}
        userSecret={user.uid}
      />
      
      
    </div>
  )
}

export default Chats